module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-wrap"
  }, [_c('div', {
    staticClass: "file-info"
  }, [_c('div', {
    staticClass: "file-info__name"
  }, [_c('span', {
    staticClass: "file-info__id"
  }, [_vm._v(_vm._s(_vm.fileId))]), _vm._v(" "), _c('span', {
    staticClass: "file-info__extension"
  }, [_vm._v(_vm._s(_vm.fileExt))])]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [(_vm.isPaused) ? _c('div', {
    staticClass: "file-info__progress"
  }, [_c('i', {
    staticClass: "fa fa-pause",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : (_vm.isStopped) ? _c('div', {
    staticClass: "file-info__progress"
  }, [_c('i', {
    staticClass: "fa fa-stop",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('div', {
    staticClass: "file-info__progress"
  }, [_vm._v(_vm._s((_vm.progress + "%")))]), _vm._v(" "), _c('div', {
    class: ("progress-bar " + _vm.progressClass),
    style: (("width: " + _vm.progress + "%;"))
  })])]), _vm._v(" "), _c('div', {
    staticClass: "file-info__controls"
  }, [(_vm.isFinished && !_vm.isSucceed) ? _c('button', {
    staticClass: "button retry",
    on: {
      "click": _vm.onRetryClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isFinished) ? [(!_vm.isStopped) ? _c('button', {
    staticClass: "button stop",
    on: {
      "click": _vm.onStopClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-stop",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isStopped && _vm.isPaused) ? _c('button', {
    staticClass: "button resume",
    on: {
      "click": _vm.onResumeClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-play",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('button', {
    staticClass: "button pause",
    on: {
      "click": _vm.onPauseClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-pause",
    attrs: {
      "aria-hidden": "true"
    }
  })])] : _c('button', {
    staticClass: "button remove",
    on: {
      "click": _vm.onRemoveClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59ae8b6a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/uploadManager/ProgressBar.vue
// module id = 911
// module chunks = 0